// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1CwGi","sendOtp":"AuthorizeToLogin_sendOtp__10uyx"};